export const ColorFirstRow = '#e4e4a1';
export const ColorSecondRow = '#efefc8';
export const ColorThirdRow = '#fbfbf0';
export const ColorDetailsRow = '#dcdcf5';
